var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import DayPicker from "react-day-picker";
import 'react-day-picker/lib/style.css';
import "./styles/CalendarStylesheet.css";
export var DayColor;
(function (DayColor) {
    DayColor[DayColor["red"] = 0] = "red";
    DayColor[DayColor["yellow"] = 1] = "yellow";
    DayColor[DayColor["green"] = 2] = "green";
    DayColor[DayColor["gray"] = 3] = "gray";
    DayColor[DayColor["none"] = 4] = "none";
})(DayColor || (DayColor = {}));
var CalendarComponent = /** @class */ (function (_super) {
    __extends(CalendarComponent, _super);
    function CalendarComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.isDaySelected = _this.isDaySelected.bind(_this);
        _this.isDayDisabled = _this.isDayDisabled.bind(_this);
        _this.renderDay = _this.renderDay.bind(_this);
        _this.colorsForDay = _this.colorsForDay.bind(_this);
        return _this;
    }
    CalendarComponent.prototype.render = function () {
        var weekdaysShort = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        var weekdaysLong = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
        var months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
        return (React.createElement("div", null,
            React.createElement(DayPicker, { selectedDays: function () { return false; }, disabledDays: this.isDayDisabled, onDayClick: this.handleOnClick, renderDay: this.renderDay, firstDayOfWeek: 1, weekdaysShort: weekdaysShort, weekdaysLong: weekdaysLong, months: months, month: this.props.initialMonth })));
    };
    CalendarComponent.prototype.renderDay = function (day, modifiers) {
        var opacity;
        if (modifiers.disabled) {
            opacity = 0.8;
        }
        else {
            opacity = 1.0;
        }
        var dateStyle = {
            color: 'black',
            textAlign: 'center',
            fontSize: 16,
            height: 18,
            marginTop: 0,
            marginBottom: 8,
            verticalAlign: 'middle',
            display: 'inline-block',
            lineHeight: '18px',
            outline: "none",
        };
        var cellStyle = {
            opacity: opacity,
            height: '30px',
            width: '30px',
            borderRadius: '50%',
            marginTop: -7,
            marginBottom: -7,
            marginLeft: -7,
            marginRight: -7,
            padding: 0,
            borderWidth: '2px',
            borderStyle: 'solid',
            overflow: 'hidden',
            lineHeight: '30px',
            textAlign: 'center',
            outline: "none",
        };
        if (this.isDaySelected(day)) {
            var selectedStyle = {
                borderColor: 'black'
            };
            cellStyle = __assign(__assign({}, cellStyle), selectedStyle);
        }
        else {
            var unSelectedStyle = {
                borderColor: 'rgb(0,0,0,0)'
            };
            cellStyle = __assign(__assign({}, cellStyle), unSelectedStyle);
        }
        var colors = this.colorsForDay(day);
        cellStyle = __assign(__assign({}, cellStyle), colors);
        var date = day.getDate();
        return (React.createElement("div", { style: cellStyle },
            React.createElement("span", { style: dateStyle }, date)));
    };
    CalendarComponent.prototype.colorsForDay = function (day) {
        switch (this.props.styleForDay(day).color) {
            case DayColor.red:
                return {
                    backgroundColor: 'red',
                };
            case DayColor.yellow:
                return {
                    backgroundColor: 'yellow',
                };
            case DayColor.green:
                return {
                    backgroundColor: '#09cf11',
                };
            case DayColor.gray:
                return {
                    backgroundColor: 'gray',
                };
            case DayColor.none:
                return {
                    backgroundColor: 'white',
                };
        }
    };
    CalendarComponent.prototype.isDaySelected = function (day) {
        return this.props.isDaySelected(day);
    };
    CalendarComponent.prototype.isDayDisabled = function (day) {
        return this.props.styleForDay(day).disabled;
    };
    CalendarComponent.prototype.handleOnClick = function (day, modifiers) {
        if (modifiers.disabled)
            return;
        this.props.selectDay(day);
    };
    return CalendarComponent;
}(React.Component));
export default CalendarComponent;
//# sourceMappingURL=CalendarComponent.js.map